<kanzi-ui-main-card
  title="{{ 'stores.title' | translate }}"
  description="{{ 'stores.description' | translate }}"
>
  <ng-template kTemplate="rightTopContent">
    <p-button
      label="{{ 'stores.actions.create' | translate }}"
      icon="pi pi-plus"
      (onClick)="onCreateStore()"
      [disabled]="isLoading()"
    ></p-button>
  </ng-template>

  <!-- Búsqueda -->
  <div class="mb-4">
    <span class="p-input-icon-left p-input-icon-right w-full md:w-6">
      <i class="pi pi-search"></i>
      <input
        pInputText
        type="text"
        [value]="searchText()"
        (input)="onSearch($event)"
        placeholder="{{ 'stores.search.placeholder' | translate }}"
        class="w-full"
      />
      @if (searchText()) {
      <i class="pi pi-times cursor-pointer" (click)="onClearSearch()"></i>
      }
    </span>
  </div>

  <!-- Loading State -->
  @if (isLoading() && stores.length === 0) {
  <div class="grid grid-nogutter">
    @for (i of [1, 2, 3, 4, 5, 6]; track i) {
    <div class="col-12 sm:col-6 md:col-4 lg:col-3 p-2">
      <p-card>
        <p-skeleton width="100%" height="150px"></p-skeleton>
        <p-skeleton width="80%" height="20px" styleClass="mt-2"></p-skeleton>
        <p-skeleton width="60%" height="15px" styleClass="mt-2"></p-skeleton>
      </p-card>
    </div>
    }
  </div>
  }

  <!-- DataView -->
  @if (!isLoading() || stores.length > 0) {
  <p-dataView [value]="stores" layout="grid">
    <ng-template pTemplate="header">
      <div class="flex justify-content-between align-items-center">
        <span class="text-lg font-semibold">
          {{ totalRecords() }}
          {{ totalRecords() === 1 ? 'store' : 'stores' }}
        </span>

        @if (isLoading()) {
        <i class="pi pi-spin pi-spinner text-primary"></i>
        }
      </div>
    </ng-template>

    <ng-template pTemplate="grid" let-stores>
      <div class="grid grid-nogutter">
        @for (store of stores; track store.id) {
        <div class="col-12 sm:col-6 md:col-4 lg:col-4 p-2">
          <p-card
            styleClass="h-full cursor-pointer hover:shadow-4 transition-all transition-duration-200"
            (click)="onViewStore(store)"
            (mouseenter)="onStoreHover(store)"
          >
            <ng-template pTemplate="header">
              <div
                class="bg-primary-gradient p-3 flex align-items-center justify-content-between"
              >
                <div class="flex align-items-center gap-2">
                  <i class="pi pi-building text-white text-2xl"></i>
                  <div>
                    <p class="text-white font-bold text-lg m-0">
                      {{ store.name }}
                    </p>
                    @if (store.external_id) {
                    <p class="text-white-alpha-80 text-sm m-0">
                      {{ store.external_id }}
                    </p>
                    }
                  </div>
                </div>
                <p-tag
                  value="{{
                    store.type?.name || ('stores.noType' | translate)
                  }}"
                  severity="success"
                  styleClass="text-xs"
                ></p-tag>
              </div>
            </ng-template>

            <div class="flex flex-column gap-2">
              <!-- Información -->
              @if (store.description) {
              <div class="text-sm text-color-secondary">
                <i class="pi pi-info-circle mr-1"></i>
                {{ store.description }}
              </div>
              } @if (store.created_by) {
              <div class="text-xs text-color-secondary">
                <i class="pi pi-user mr-1"></i>
                {{ 'stores.createdBy' | translate }}:
                {{ store.created_by.username }}
              </div>
              } @if (store.created) {
              <div class="text-xs text-color-secondary">
                <i class="pi pi-calendar mr-1"></i>
                {{ store.created }}
              </div>
              }
            </div>

            <ng-template pTemplate="footer">
              <div class="flex justify-content-between align-items-center">
                <p-button
                  label="{{ 'stores.actions.view' | translate }}"
                  icon="pi pi-eye"
                  styleClass="p-button-text p-button-sm"
                  (onClick)="onViewStore(store)"
                ></p-button>

                <div class="flex gap-1">
                  <p-button
                    icon="pi pi-pencil"
                    styleClass="p-button-text p-button-sm"
                    [pTooltip]="'stores.actions.edit' | translate"
                    (onClick)="onEditStore(store, $event)"
                  ></p-button>

                  <p-button
                    icon="pi pi-trash"
                    styleClass="p-button-text p-button-sm p-button-danger"
                    [pTooltip]="'stores.actions.delete' | translate"
                    (onClick)="onDeleteStore(store, $event)"
                    [loading]="deleteMutation.isPending()"
                  ></p-button>
                </div>
              </div>
            </ng-template>
          </p-card>
        </div>
        }
      </div>
    </ng-template>

    <ng-template pTemplate="empty">
      <div class="text-center py-5">
        <i class="pi pi-building text-6xl text-color-secondary mb-3"></i>
        <p class="text-xl font-semibold text-color-secondary">
          {{ 'stores.empty.title' | translate }}
        </p>
        <p class="text-color-secondary">
          {{ 'stores.empty.message' | translate }}
        </p>
        <p-button
          label="{{ 'stores.actions.create' | translate }}"
          icon="pi pi-plus"
          (onClick)="onCreateStore()"
          styleClass="mt-3"
        ></p-button>
      </div>
    </ng-template>
  </p-dataView>
  }
</kanzi-ui-main-card>

<!-- Confirm Dialog -->
<p-confirmDialog></p-confirmDialog>
